var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:{'text-center': _vm.centered}},[_c('share-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }